import { useQuery, skipToken } from '@apollo/client/react';

import { OfferEventDetailDrawer } from 'offer/components/OfferEventDetailDrawer';
import { OfferDocument } from 'graphql/types';
import { ApolloError } from 'common/components/ApolloError';
import { useRouteQuery } from 'route/hooks/useRouteQuery';

interface IProps {
    offerId?: string;
    open?: boolean;
    onClose?: () => void;
}

export const OfferDetailDrawer = ({ offerId, open, onClose }: IProps) => {
    const routeQuery = useRouteQuery();
    const id = offerId || routeQuery.get('id');

    const { data, loading, error } = useQuery(
        OfferDocument,
        id && open ? { variables: { id } } : skipToken
    );

    const { offer } = data || {};
    const { detailEventId } = offer || {};

    return (
        <>
            {error && <ApolloError error={error} />}

            <OfferEventDetailDrawer
                includeOfferFields
                isOfferDetailDrawer
                loading={loading}
                offerEventId={detailEventId ?? undefined}
                offerLoading={loading}
                open={open}
                onClose={onClose}
            />
        </>
    );
};
